export const LAWYERS = '/lawyers';
export const LAWYER = id => `${LAWYERS}/${id}`;

export const PROJECT = id => `/projects/${id}`;

export const PANEL_LAWYERS = projectID => `${LAWYERS}${PROJECT(projectID)}`;
export const PANEL_LAWYER = (projectID, id) => `${LAWYER(id)}${PROJECT(projectID)}`;

export const BOOKING_CASES = bookingID => `${LAWYERS}/cases/${bookingID}`;
export const BOOKING_AGING_CASES = `${LAWYERS}/cases/aging`;
export const LAWYER_CASES = id => `${LAWYER(id)}/cases`;
export const LAWYER_CASE = (id, caseID) => `${LAWYER_CASES(id)}/${caseID}`;
export const LAWYER_CASE_DETAILS = (id, caseID) => `${LAWYER_CASE(id, caseID)}/details`;

export const LAWYER_INVITES = `${LAWYERS}/invites`;
export const INVITE_LAWYER = projectID => `${LAWYERS}/invite/${projectID}`;
export const LAWYER_RESEND_INVITE = inviteID => `${LAWYERS}/invitation/${inviteID}/resend`;

export const LAWYER_REPORT_CASES_SUMMARY_COUNT = companyID => `${LAWYERS}/report/${companyID}/cases_summary_count`;



// WEBPACK FOOTER //
// ./src/constants/apiEndpoints.js